export default __webpack_public_path__ + "static/media/broker-welcome-skip-help.680ddc17.png";